import React, { useState, useEffect } from "react";
import Hooks from "./Hooks";

export default function HookWrapper() {
  const [showHooks, setShowHooks] = useState(true);
  const [hookButton, setHookButton] = useState("Show Hooks");

  return (
    <div style={{textAlign:"center"}}>
      <h2
        style={{
          margin:"1rem",
          textDecoration: "underline",
          color: "cornflowerblue",
          textAlign: "center",
        }}
      >
        React Hooks at a glance
      </h2>
      <div style={{ textAlign: "justify", width: "70%", margin: "auto" }}>
        <h6>
          React hooks allows us to use state and React lifecycle features
          without using class and React component lifecycle methods. Hooks
          introduced v16.8 and are Great. Have a look at few important hooks.
        </h6>
      </div>
      {/* <button
        className="btn btn-primary"
        style={{ marginTop: "2px", marginBottom: "50px", backgroundColor:"royalblue", borderRadius: "1rem" }}
        onClick={() => {
          setShowHooks((prev) => !prev);
          console.log(hookButton);
          setHookButton(
            hookButton === "Show Hooks" ? "Hide Hooks" : "Show Hooks"
          );
        }}
      > */}
      {/* {hookButton} */}
      {/* </button> */}
      {showHooks ? <Hooks /> : ""}
    </div>
  );
}
